import { render, staticRenderFns } from "./AudioView.vue?vue&type=template&id=158414c6&scoped=true"
import script from "./AudioView.vue?vue&type=script&lang=js"
export * from "./AudioView.vue?vue&type=script&lang=js"
import style0 from "./AudioView.vue?vue&type=style&index=0&id=158414c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158414c6",
  null
  
)

export default component.exports